export default __webpack_public_path__ + "0928cca6.jpg";